import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  private formHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  };

  private eventsSaved: any[] = [];

  constructor(private http: HttpClient) { }

  addEventSaved(event: any) {
    this.eventsSaved.push(event);
  }

  emptyEventsSaved() {
    this.eventsSaved = [];
  }

  getEventsSaved(idEvent: any) {
    return this.eventsSaved.find(event => event.id == idEvent);
  }

  getEventsActive(page: number = 1, filters?: { search?: string; date_from?: string; date_to?: string }) {
    const id_business = localStorage.getItem('id_business');
    let url = `${AppSettings.API_URI_V2}/events?active=true&id_company=${id_business}&publish=true&draft=false&page=${page}&per_page=12&sort=start_date:asc`;
    if (filters?.search) {
      url += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters?.date_from) {
      url += `&date_from=${filters.date_from}`;
    }
    if (filters?.date_to) {
      url += `&date_to=${filters.date_to}`;
    }
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getEventById(idEvent: number) {
    return this.http.get<any>(AppSettings.API_URI_V2 + '/events/' + idEvent).pipe(
      map(data => {
        return data;
      })
    );
  }

  getMapEventBySession(idEvent: number, idSession: number) {
    const url = `${AppSettings.API_URI_V2}/admin/events/${idEvent}/sessions/${idSession}/map`;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      }), catchError(err => { return throwError(() => err); })
    );
  }

  getInfoCapacityEvent(session: number) {
    return this.http
      .get<any>(AppSettings.API_URI_V2 + '/info/capacity/session/' + session)
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  getCountTicketsByEvent(idSession: number) {
    const url = `${AppSettings.API_URI_V2}/count/tickets/enabled/session/${idSession}`;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      }), catchError(err => { return throwError(() => err); })
    );
  }

  // Info del pedido/reserva al que pertenece cada butaca ocupada de una sesión (indexado
  // por id_seat). En taquilla pedimos también las butacas de reservas (include_reservations)
  // para mostrar al hacer hover a qué pedido o reserva pertenece cada butaca.
  getEventSeatsOrders(idEvent: number, idSession: number) {
    const url = `${AppSettings.API_URI_V2}/admin/events/${idEvent}/sessions/${idSession}/seats-orders?include_reservations=1`;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      }), catchError(err => { return throwError(() => err); })
    );
  }

  // Canales de venta (id → nombre) para mostrar el canal del pedido en el tooltip.
  getSalesChannels() {
    const url = `${AppSettings.API_URI_V2}/order/sales-channels`;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      }), catchError(err => { return throwError(() => err); })
    );
  }
}
